module.exports = __webpack_public_path__ + "static/media/support-header.bee1d58b.svg";